<template>
  <div>
    <MfaPopup @authenticated="fetchDatas"></MfaPopup>
    <h1>{{ $route.meta.title }}</h1>
    <div class="my-container">
      <div class="box">
        <h2>Procédures</h2>
        <table class="proc-list">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Description</th>
              <th>Système</th>
              <th>Périmètre</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="proc of procedures" :key="proc.Id">
              <td>{{ proc.Name }}</td>
              <td>{{ proc.Description }}</td>
              <td>{{ proc.ConnectionName }}</td>
              <td>{{ proc.Perimeter }}</td>
              <td><button class="button-primary" @click="selectProcedure(proc.Id)">Sélectionner</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="box">
        <h2>Paramètres</h2>
        <div v-if="selectedProcedure">
          <label class="proc-name">
            Procédure :
            <input class="form-control" type="text" readonly
              :value="selectedProcedureObj && selectedProcedureObj.Name" />
          </label>
          <ul class="param-list">
            <li v-for="param of parameters" :key="param.ParamName">
              <label>
                <small>{{ param.Type }}</small>
                <br />
                {{ param.ParamName }}
                <small v-if="param.HasDefaultValue">Optionnel</small>
                <input v-if="param.Type == 'int' || param.Type == 'bigint'" class="form-control" type="number"
                  v-model="paramsModel[param.ParamName]" />
                <input v-else-if="param.Type == 'decimal' || param.Type == 'float'" class="form-control" type="number"
                  step="0.01" v-model="paramsModel[param.ParamName]" />
                <input v-else-if="param.Type == 'bit'" type="checkbox" v-model="paramsModel[param.ParamName]" />
                <input v-else class="form-control" type="text" v-model="paramsModel[param.ParamName]" />
              </label>
              <br />
              <label class="nullable-label" v-if="param.IsNullable">
                <input type="checkbox" :checked="paramsModel[param.ParamName] === null"
                  @click="nullish($event, param.ParamName)" />
                NULL
              </label>
            </li>
          </ul>
          <button class="btn btn-exec" @click="exec">Exécuter</button>
          <button v-if="results.length > 0 || dataLoaded" class="btn btn-warning btn-export"
            @click="exportData">Exporter</button>

          <vue-good-table v-if="results.length > 0" class="results" :columns="columns" :rows="results"
            :pagination-options="{
      enabled: true,
      rowsPerPageLabel: 'Lignes par page',
      ofLabel: 'sur',
      nextLabel: 'Suivant',
      prevLabel: 'Précédent',
      allLabel: 'Toutes'
    }">
          </vue-good-table>
        </div>
        <span class="text-center" v-if="results.length === 0 && dataLoaded">Les résultats sont trop grand, et ne sont donc pas affichés. Vous pouvez exporter en excel pour les visualiser</span>
      </div>
    </div>
  </div>
</template>

<script>
import MfaPopup from "@/components/MfaPopup";
import { getProcedures, getProcParams, execProcedure } from "@/utils/procDyn";
import { saveAs } from 'file-saver';

let _excelFileBase64 = null

export default {
  name: "ProcDyn",
  components: { MfaPopup },
  data() {
    return {
      procedures: [],
      selectedProcedure: null,
      parameters: [],
      paramsModel: {},
      results: [],
      dataLoaded: false
    }
  },
  mounted() { },
  watch: {
    selectedProcedure() {
      //Lorsqu'on change de procédure, on réinitialise les paramètres/résultats de requête
      this.parameters = [];
      this.paramsModel = {};
      this.results = [];
      _excelFileBase64 = null;
      this.dataLoaded = false;
      if (this.selectedProcedure) {
        getProcParams(this.selectedProcedure).then(res => {
          this.parameters = res;
          for (const param of res) {
            this.$set(this.paramsModel, param.ParamName, param.IsNullable ? null : "")
          }
        })
      }
    }
  },
  methods: {
    fetchDatas() {
      this.selectedProcedure = null;
      getProcedures().then(res => {
        this.procedures = res;
      })
    },
    selectProcedure(procId) {
      this.selectedProcedure = procId;
    },
    exec() {
      // On exécute une procédure en Back, et récupère les résultats
      execProcedure(this.selectedProcedure, this.paramsModel).then(res => {
        _excelFileBase64 = res.excelFileBase64;
        this.results = res.results;
        this.dataLoaded = true;
      })
    },
    b64toBlob(base64) {
      return fetch(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`).then(res => res.blob());
    },
    exportData() {
      this.b64toBlob(_excelFileBase64).then(blob => {
        saveAs(blob, "Export.xlsx");
      })
    },
    nullish(e, paramName) {

      if (this.paramsModel[paramName] !== null) {// Dans ce cas, la coche change
        // On ne prevent pas, car la coche change
        this.paramsModel = Object.assign({}, this.paramsModel, { [paramName]: null })
      } else { // on prévent car la coche ne doit pas changer
        e.preventDefault();
      }
    }
  },
  computed: {
    selectedProcedureObj() {
      if (this.procedures && this.selectedProcedure)
        return this.procedures.find(p => p.Id == this.selectedProcedure);
      return null;
    },
    columns() {
      let res = [];
      if (this.results.length > 0) {
        const row = this.results[0];
        for (let key in row) {
          if (!res.find(col => col.field == key)) {// Si la colonne n'a pas encore été ajoutée
            res.push({ field: key, label: key })
          }
        }
      }
      return res;
    }
  }
}
</script>

<style scoped>
.my-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.box {
  background: white;
  border-radius: 6px;
  box-shadow: 1px 1px 12px 0 rgba(0, 0, 0, 0.4);
  min-height: 60vh;
  padding: 12px 24px;
  max-width: 100%;
  overflow-x: scroll;
}

.proc-list {
  width: 100%;
}

.proc-name {
  width: 100%;
  margin-bottom: 16px;
}

.param-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 260px);
  column-gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
}

.param-list input[type="checkbox"] {
  display: block;
  margin-top: 0.6em;
}

.param-list li .nullable-label input[type="checkbox"] {
  display: inline;
  margin: 0;
}

.btn-export {
  margin-bottom: 12px;
}

.btn-exec {
  display: block;
  margin: auto;
  color: white;
  background: #A7C13C;
  margin-bottom: 24px;
}

.results {
  max-width: 100%;
  overflow-x: scroll;
}

td {
  padding: 4px 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Admin/ProcDyn.vue